// extracted by mini-css-extract-plugin
export default {"ScreenSizeCard":"ScreenSizeCard_ScreenSizeCard__pSpbg","icon":"ScreenSizeCard_icon__Hb1Up","descriptionContent":"ScreenSizeCard_descriptionContent__wSdBs"};